<template>
  <div>
    <div class="footer-wrapper box-desc-social">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="list-info">
              <div class="box-desc">
                <div class="title">
                  About Company
                </div>
                <div class="desc">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio minus incidunt, quos libero a illo amet deleniti tempore, modi obcaecati autem vitae, labore doloribus reiciendis veniam quod minima quibusdam reprehenderit!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="list-info">
              <div class="box-desc">
                <div class="title">
                  Contact Us
                </div>
                <div class="desc">
                  <p>
                    Address: Jl TB Simatupang No.30 Gd Talavera Suite 6 BGH
                  </p>
                  <p>
                    Phone: 085692268882
                  </p>
                  <p>
                    Email: sales@company.com
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="box-desc-social">
              <div class="title">
                Follow Us
              </div>
              <div class="social-media">
                <a href="http://facebook.com" class="btn btn-primary">
                  <i class="fa fa-facebook"></i>
                </a>
                <a href="http://twitter.com" class="btn btn-info">
                  <i class="fa fa-twitter"></i>
                </a>
                <a href="http://google.com" class="btn btn-danger">
                  <i class="fa fa-google-plus"></i>
                </a>
                <a href="http://linkedin.com" class="btn btn-primary">
                  <i class="fa fa-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-corpyright">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <span>2017 &copy; Corpyright - PT. Consultant IT Profesional</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'appFooter' }
</script>



// WEBPACK FOOTER //
// appFooter.vue?63cf449f